<template>
  <v-container
    class="py-8 px-6"
    fluid
  >
    <PageTitle
      icon="mdi-home"
      main="TCweb"
      sub="Assistência Social"
      home='/home'
    />
    <v-container>
      <v-row
        align="center"
        justify="center"
      >
        <v-col
          v-for="mm in buttons"
          :key="mm.id"
          class="mx-1 auto px-1"
          cols="12"
          sm="3"
          md="2"
          lg="1"
        >
          <v-card
            elevation="7"
            height="90"
            :to="mm.link"
          >
            <v-card
              color="white"
              class="py-1 mt-2 mb-0"
              flat
              tile
            >
              <v-img
                :src="mm.icon"
                max-width="50"
                class="my-1 mx-auto"
              >
              </v-img>
            </v-card>
            <v-card-text class="black--text ma-0 pt-0 px-1 text-menu">
              {{ mm.nome }}
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import PageTitle from '@/components/template/PageTitle'
// import Stat from './Stat'
// import axios from 'axios'
// import { baseApiUrl } from '../../global'
export default {
  name: 'Social',
  components: { PageTitle },
  data: () => ({
    buttons: [
      { id: 1, nome: 'Solicitação', titulo: 'Cadastro de solicitações diversas', icon: require('@/assets/icons/pedido.png'), link: '/social/beneficios' },
      { id: 2, nome: 'Cidadão', titulo: 'Cadastro de pessoas', icon: require('@/assets/icons/person.png'), link: '/social/pessoas' },
      { id: 3, nome: 'Estatísticas', titulo: 'Estatisticas do cadastro', icon: require('@/assets/icons/analytic.png'), link: '/social/statisticas' }
    ]
  })

}
</script>

<style scoped>
.text-menu {
  text-align: center !important;
  font-size: 0.7rem !important;
  line-height: 0.75rem;
}
</style>
